import { render } from "./Smuggling.vue?vue&type=template&id=c6b5a2d6"
import script from "./Smuggling.vue?vue&type=script&lang=js"
export * from "./Smuggling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__